import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './ProgressCheckboxStyles.module.scss.js';

var ProgressCheckbox = (function (_super) {
    __extends(ProgressCheckbox, _super);
    function ProgressCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this._start = function () {
            _this.interval = setInterval(function () {
                if (_this.state.topOffset !== 0) {
                    _this.setState({
                        topOffset: _this.state.topOffset - 1,
                        isUpdating: true,
                    });
                }
            }, 120);
        };
        _this._ready = function () {
            if (_this.interval) {
                clearInterval(_this.interval);
            }
            _this.setState({
                topOffset: 0,
                delay: 0,
            });
        };
        _this.state = {
            topOffset: 60,
            delay: 4,
            isUpdating: false,
        };
        return _this;
    }
    ProgressCheckbox.prototype.componentDidMount = function () {
        if (this.props.isReady) {
            this._ready();
        }
        else {
            this._start();
        }
    };
    ProgressCheckbox.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.isReady) {
            this._ready();
        }
    };
    ProgressCheckbox.prototype.render = function () {
        var _a;
        if (!this.state.isUpdating && !this.props.isReady) {
            this._start();
        }
        return (React.createElement("div", { className: classNames(styles.container, this.props.className, (_a = {},
                _a[styles.ready] = this.props.isReady,
                _a[styles.anchorIcon] = this.props.anchorIcon && this.props.isReady,
                _a)), onClick: this.props.onClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave },
            React.createElement("div", { className: styles.spacer }),
            React.createElement("div", { className: styles.levelProgress, style: {
                    transform: "translateY(" + this.state.topOffset + "px)",
                } })));
    };
    return ProgressCheckbox;
}(React.PureComponent));

export { ProgressCheckbox as default };
//# sourceMappingURL=ProgressCheckbox.js.map
